import { render, staticRenderFns } from "./DetailDeposit.vue?vue&type=template&id=6bfdb6d0&scoped=true"
import script from "./DetailDeposit.vue?vue&type=script&lang=ts"
export * from "./DetailDeposit.vue?vue&type=script&lang=ts"
import style0 from "./DetailDeposit.vue?vue&type=style&index=0&id=6bfdb6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdb6d0",
  null
  
)

export default component.exports